// @ts-nocheck
import React, { useState, useContext, useEffect } from 'react';
import Router from 'next/router';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import Fetch from '@/utils/Fetch';
import SettingsMenu from '@/components/settings/menu';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import ManageWebForm from '@/components/webform/manage';
import { createFileRoute } from '@tanstack/react-router'



function CreateWebForm({  }: any) {


    let currPath = '';
    if (Router.router) {
        currPath = Router.router.asPath;
    }


    const [formIsDirty, setFormIsDirty] = useState(false);
    const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
    const [customerStatus, setCustomerStatus] = useState<any>(null);
    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
            setCustomerStatus(subscriptionInfo.CustomerStatus);
        }
    }

    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if ((accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) && customerStatus !== "Trial" && customerStatus !== null) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus, customerStatus]);

    Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions);

    const [inputs, setInputs] = useState({
        Name: null,
        WebFormType: null,
        Origin: null,
        QueryTypeID: null,
        MetaData: null,
        Title: null,
        Style: JSON.stringify({ background: "#FFFFFF", color: "#000000" }),
        FollowUpTimespan: 0,
        EmployeeID: null,
        QueryStatusID: null
    });

    return (
        <div className="settings-container">
            {/*<div className="row">
                <div className="title">
                    <Breadcrumbs
                        crumbs={[
                            { text: 'Settings', link: '/settings', suppressLink: true },
                            { text: 'Web Forms', link: '/settings/webform/list' },
                            { text: 'Create Web Form', link: '/settings/webform/create' },
                        ]}
                    />
                </div>
            </div>*/}
            <div className="row">
                <SettingsMenu urlPath={currPath} />
                <ManageWebForm
                    isNew={true}
                   
                    webFormToEdit={inputs}
                />

            </div>

            <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

            <style jsx>{`


        .style-heading {
            margin: 24px 0 8px 0;
            font-weight: bold;
        }

        .add-location {
          align-items: center;
          color: ${colors.bluePrimary};
          cursor: pointer;
          display: flex;
          font-weight: bold;
        }
        .add-location img {
          margin: 2px 0.5rem 0 0;
        }
        .container {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          height: 100%;
          padding: 1.5rem 3rem;
          overflow-x: hidden;
        }
        .row {
            display: flex;
        }
        .column {
          display: flex;
          flex-direction: column;
          width: ${layout.inputWidth};
        }
        .column + .column {
            margin-left: 1.25rem;
          }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .title {
          align-items: center;
          color: ${colors.darkPrimary};
          display: flex;
          height: 2.5rem;
          width: 100%;
        }
        .title h1 {
          font-size: 32px;
          margin: 6px 0 2rem 0;
        }
        .title p {
          font-size: 14px;
          margin: 0;
        }
   
        .row-align {
          align-items: center;
          height: 1.75rem
        }
        .empty {
          align-items: center;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          height: fit-content;
          justify-content: center;
          margin-left: 1.5rem;
          width: 520px;
        }
        .empty img {
          height: 110px;
          margin-bottom: 1rem;
        }
        .empty h3 {
          color: ${colors.darkSecondary};
          font-size: 16px;
          margin: 0 0 0.75rem;
        }
        .empty p {
          color: ${colors.blueGrey};
          margin: 0;
          text-align: center;
        }

        .actions {
            margin-top: 1rem;
            padding-bottom: 1rem;
            display: flex;
            flex-direction: row-reverse;
          }
  
          .actions :global(.button){
            margin-left: 0.5rem;
            margin-top: 0;
            padding: 0 1rem;
            white-space: nowrap;
        }
      `}</style>
        </div>
    );
}

export default CreateWebForm;

export const Route = createFileRoute('/_authenticated/settings/webform/create')({ component: CreateWebForm })
